import script from "./PopupInfoButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupInfoButton.vue?vue&type=script&setup=true&lang=ts"

import "./PopupInfoButton.vue?vue&type=style&index=0&id=9589f7d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9589f7d0"]])

export default __exports__